if (window.location.href == "https://thehemphaus.com/collections/delta-8-thc-flower/products/delta-8-thc-moonrocks") {
   window.location.href = 'https://thehemphaus.com/products/delta-8-thc-moonrocks/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/delta-8-thc-flower/products/moon-walker-og-delta-8-thc-flower") {
   window.location.href = 'https://thehemphaus.com/products/moon-walker-og-delta-8-thc-flower/'; 
}
if(window.location.href == "https://thehemphaus.com/collections/delta-8-thc-flower/products/grandaddy-purps-delta-8-thc-flower") {
  window.location.href = 'https://thehemphaus.com/products/grandaddy-purps-delta-8-thc-flower/';
}
if(window.location.href == "https://thehemphaus.com/collections/delta-8-thc-flower/products/white-widow-cbg-delta-8-thc-flower") {
  window.location.href = 'https://thehemphaus.com/products/white-widow-cbg-delta-8-thc-flower/';
}
if(window.location.href == "https://thehemphaus.com/collections/delta-8-thc-flower/products/exotic-alpen-gleaux-d8-purple-weed") {
  window.location.href = 'https://thehemphaus.com/products/exotic-alpen-gleaux-d8-purple-weed/';
}
if(window.location.href == "https://thehemphaus.com/collections/delta-8-thc-flower/products/bubba-kush-delta-8-thc-flower/") {
  window.location.href = 'https://thehemphaus.com/products/bubba-kush-delta-8-thc-flower/';
}
if (window.location.href == "https://thehemphaus.com/collections/cbd/products/full-spectrum-hemp-cbd-balm") {
   window.location.href = 'https://thehemphaus.com/products/full-spectrum-hemp-cbd-balm/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/cbd/products/100mg-hemp-cbd-tincture-cat-small-pet") {
   window.location.href = 'https://thehemphaus.com/products/100mg-hemp-cbd-tincture-cat-small-pet/'; 
}
if (window.location.href == "https://thehemphaus.com/products/cream-knock-out-thcp-live-resin-disposable-rechargeable-vape-grape-goji-og-sativa-strain-2-2-grams") {
   window.location.href = 'https://thehemphaus.com/products/cream-knock-out-thcp-live-resin-disposable-rechargeable-vape-grape-goji-og-sativa-strain-2-2-grams/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/cbd/products/baileys-cbd-300mg-30ml") {
   window.location.href = 'https://thehemphaus.com/products/baileys-cbd-300mg-30ml/'; 
}
if (window.location.href == "https://thehemphaus.com/products/cbg-isolate") {
   window.location.href = 'https://thehemphaus.com/products/cbg-isolate/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/cbd/products/omega-hemp-soft-chews-30-count") {
   window.location.href = 'https://thehemphaus.com/products/omega-hemp-soft-chews-30-count/'; 
}
if (window.location.href == "https://thehemphaus.com/products/cascade-pineapple-delta-8-thc-pre-rolls") {
   window.location.href = 'https://thehemphaus.com/products/cascade-pineapple-delta-8-thc-pre-rolls/'; 
}
if (window.location.href == "https://thehemphaus.com/products/cookies-cbd-flower") {
   window.location.href = 'https://thehemphaus.com/products/cookies-cbd-flower/'; 
}
if (window.location.href == "https://thehemphaus.com/blogs/news/cbg-hemp-flower-is-in-demand?_pos=4&_sid=49f570f78&_ss=r") {
   window.location.href = 'https://thehemphaus.com/blogs/news/cbg-hemp-flower-is-in-demand/'; 
}
if (window.location.href == "https://www.thehemphaus.com/blogs/news/introducing-delta-8-thc") {
   window.location.href = 'https://www.thehemphaus.com/blogs/news/introducing-delta-8-thc/'; 
}
if (window.location.href == "https://thehemphaus.com/products/hhc-gummies") {
   window.location.href = 'https://thehemphaus.com/products/hhc-gummies/'; 
}
if (window.location.href == "https://thehemphaus.com/products/cheesecake-strain") {
   window.location.href = 'https://thehemphaus.com/products/cheesecake-strain/'; 
}
if (window.location.href == "https://thehemphaus.com/products/cream-delta-8-disposable-blue-zkittlez") {
   window.location.href = 'https://thehemphaus.com/products/cream-delta-8-disposable-blue-zkittlez/'; 
}
if (window.location.href == "https://thehemphaus.com/products/skywalker-og-delta-10-flower") {
   window.location.href = 'https://thehemphaus.com/products/skywalker-og-delta-10-flower/'; 
}
if (window.location.href == "https://thehemphaus.com/products/vertly-hemp-infused-lip-balm-rose") {
   window.location.href = 'https://thehemphaus.com/products/vertly-hemp-infused-lip-balm-rose/'; 
}
if (window.location.href == "https://thehemphaus.com/products/girl-scout-cookies-thco-flower") {
   window.location.href = 'https://thehemphaus.com/products/girl-scout-cookies-thco-flower/'; 
}
if (window.location.href == "https://thehemphaus.com/products/vegan-delta-8-thc-gummies-strawberry-lemonade-50-mg") {
   window.location.href = 'https://thehemphaus.com/products/vegan-delta-8-thc-gummies-strawberry-lemonade-50-mg/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/cbd/products/baileys-cbd-600mg-60ml") {
   window.location.href = 'https://thehemphaus.com/products/baileys-cbd-600mg-60ml/'; 
}
if (window.location.href == "https://thehemphaus.com/products/cherry-cheesecake-delta-8-thc-pre-rolls") {
   window.location.href = 'https://thehemphaus.com/products/cherry-cheesecake-delta-8-thc-pre-rolls/'; 
}
if (window.location.href == "https://thehemphaus.com/products/vegan-gummies-ananda-hemp-broad-spectrum-cbd-gummies-15mg-per-gummy") {
   window.location.href = 'https://thehemphaus.com/products/vegan-gummies-ananda-hemp-broad-spectrum-cbd-gummies-15mg-per-gummy/'; 
}
if (window.location.href == "https://thehemphaus.com/products/cbd-cigarettes-healix-hemp-rolls") {
   window.location.href = 'https://thehemphaus.com/products/cbd-cigarettes-healix-hemp-rolls/'; 
}
if (window.location.href == "https://thehemphaus.com/products/chaga-powder") {
   window.location.href = 'https://thehemphaus.com/products/chaga-powder/'; 
}
if (window.location.href == "https://thehemphaus.com/products/cream-delta-8-vape-disposable-berry-gelato") {
   window.location.href = 'https://thehemphaus.com/products/cream-delta-8-vape-disposable-berry-gelato/'; 
}
if (window.location.href == "https://thehemphaus.com/products/vitality-mushroom-powder") {
   window.location.href = 'https://thehemphaus.com/products/vitality-mushroom-powder/'; 
}
if (window.location.href == "https://thehemphaus.com/products/cream-hhc-disposable-rechargeable-vape-hawaiian-haze") {
   window.location.href = 'https://thehemphaus.com/products/cream-hhc-disposable-rechargeable-vape-hawaiian-haze/'; 
}
if (window.location.href == "https://thehemphaus.com/products/redwood-reserves-cbd-cigarettes") {
   window.location.href = 'https://thehemphaus.com/products/redwood-reserves-cbd-cigarettes/'; 
}
if (window.location.href == "https://thehemphaus.com/products/cream-gummies-30mg-cbd-10mg-thc-per-gummy-assorted-flavors") {
   window.location.href = 'https://thehemphaus.com/products/cream-gummies-30mg-cbd-10mg-thc-per-gummy-assorted-flavors/'; 
}
if (window.location.href == "https://thehemphaus.com/products/zkittles-cbd-hemp-flower-light-assisted-greenhouse") {
   window.location.href = 'https://thehemphaus.com/products/zkittles-cbd-hemp-flower-light-assisted-greenhouse/'; 
}
if (window.location.href == "https://thehemphaus.com/products/northern-lights-thco-flower") {
   window.location.href = 'https://thehemphaus.com/products/northern-lights-thco-flower/'; 
}
if (window.location.href == "https://thehemphaus.com/blogs/news/the-secret-life-and-benefits-of-the-cannabinoid-cbg?_pos=1&_sid=49f570f78&_ss=r") {
   window.location.href = 'https://thehemphaus.com/blogs/news/the-secret-life-and-benefits-of-the-cannabinoid-cbg/'; 
}
if (window.location.href == "https://thehemphaus.com/products/turkey-tail-powder") {
   window.location.href = 'https://thehemphaus.com/products/turkey-tail-powder/'; 
}
if (window.location.href == "https://thehemphaus.com/products/delta-8-gummies-250mg") {
   window.location.href = 'https://thehemphaus.com/products/delta-8-gummies-250mg/'; 
}
if (window.location.href == "https://thehemphaus.com/products/puffin-hemp-liposomal-hemp-actives-1000-puffin-health-liposomal-vitamin-c-bundle") {
   window.location.href = 'https://thehemphaus.com/products/puffin-hemp-liposomal-hemp-actives-1000-puffin-health-liposomal-vitamin-c-bundle/'; 
}
if (window.location.href == "https://thehemphaus.com/products/vegan-delta-8-thc-gummies-strawberry-lemonade-25-mg") {
   window.location.href = 'https://thehemphaus.com/products/vegan-delta-8-thc-gummies-strawberry-lemonade-25-mg/'; 
}
if (window.location.href == "https://thehemphaus.com/products/chemo-dawg-thco-flower") {
   window.location.href = 'https://thehemphaus.com/products/chemo-dawg-thco-flower/'; 
}
if (window.location.href == "https://thehemphaus.com/products/orangelato-delta-10-flower") {
   window.location.href = 'https://thehemphaus.com/products/orangelato-delta-10-flower/'; 
}
if (window.location.href == "https://thehemphaus.com/products/delta-9-thc-icee-rocky-mountain-ice") {
   window.location.href = 'https://thehemphaus.com/products/delta-9-thc-icee-rocky-mountain-ice/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/cbd/products/gmo-cookies-strain") {
   window.location.href = 'https://thehemphaus.com/products/gmo-cookies-strain/'; 
}
if (window.location.href == "https://thehemphaus.com/products/vegan-delta-8-thc-gummies-blue-rasberry-25-mg") {
   window.location.href = 'https://thehemphaus.com/products/vegan-delta-8-thc-gummies-blue-rasberry-25-mg/'; 
}
if (window.location.href == "https://thehemphaus.com/products/blueberry-lemonade-delta-10-thc-gummies") {
   window.location.href = 'https://thehemphaus.com/products/blueberry-lemonade-delta-10-thc-gummies/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/cbd/products/baileys-cbd-1500mg-60ml-tincture-cbd-oil-for-pets") {
   window.location.href = 'https://thehemphaus.com/products/baileys-cbd-1500mg-60ml-tincture-cbd-oil-for-pets/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/cbd-pre-rolls/products/delta-8-thc-pre-rolls-bubba-kush") {
   window.location.href = 'https://thehemphaus.com/products/bubba-kush-pre-rolls-delta-8-thc/'; 
}
if (window.location.href == "https://thehemphaus.com/products/biscotti-delta-8-thc-pre-rolls") {
   window.location.href = 'https://thehemphaus.com/products/biscotti-delta-8-thc-pre-rolls/'; 
}
if (window.location.href == "https://thehemphaus.com/products/space-cakes-delta-8-thc-pre-rolls") {
   window.location.href = 'https://thehemphaus.com/products/space-cakes-delta-8-thc-pre-rolls/'; 
}
if (window.location.href == "https://thehemphaus.com/products/sour-diesel-delta-8-thc-pre-rolls") {
   window.location.href = 'https://thehemphaus.com/products/sour-diesel-delta-8-thc-pre-rolls/'; 
}
if (window.location.href == "https://thehemphaus.com/products/headband-delta-8-thc-pre-rolls") {
   window.location.href = 'https://thehemphaus.com/products/headband-delta-8-thc-pre-rolls/'; 
}
if (window.location.href == "https://thehemphaus.com/products/purple-gas-thco-flower") {
   window.location.href = 'https://thehemphaus.com/products/purple-gas-thco-flower/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/cbd/products/baileys-full-spectrum-hemp-derived-cbd-oil-for-dogs-150mg-15ml-tincture") {
   window.location.href = 'https://thehemphaus.com/products/baileys-full-spectrum-hemp-derived-cbd-oil-for-dogs-150mg-15ml-tincture/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/frontpage/products/cbn-isolate") {
   window.location.href = 'https://thehemphaus.com/products/cbn-isolate/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/cbd-pets/products/omega-hemp-soft-chews-bacon-flavored-5-count-sample-pack") {
   window.location.href = 'https://thehemphaus.com/products/omega-hemp-soft-chews-bacon-flavored-5-count-sample-pack/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/cbd-pets/products/baileys-cbd-300mg-30ml") {
   window.location.href = 'https://thehemphaus.com/products/baileys-cbd-300mg-30ml/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/frontpage?page=1") {
   window.location.href = 'https://thehemphaus.com/collections/frontpage/'; 
}
if (window.location.href == "https://thehemphaus.com/products/white-widow-cbg-preroll") {
   window.location.href = 'https://thehemphaus.com/products/white-widow-cbg-preroll/'; 
}
if (window.location.href == "https://thehemphaus.com/products/special-sauce-cbd-hemp-flower-light-assisted-greenhouse") {
   window.location.href = 'https://thehemphaus.com/products/special-sauce-cbd-hemp-flower-light-assisted-greenhouse/'; 
}
if (window.location.href == "https://thehemphaus.com/products/sour-diesel-cbd-flower") {
   window.location.href = 'https://thehemphaus.com/products/sour-diesel-cbd-flower/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/frontpage/products/zkittles-cbd-hemp-flower-light-assisted-greenhouse") {
   window.location.href = 'https://thehemphaus.com/products/zkittles-cbd-hemp-flower-light-assisted-greenhouse/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/topicals/products/puffin-hemp-puffin-ice-cbd-liposomal-muscle-rub") {
   window.location.href = 'https://thehemphaus.com/products/puffin-hemp-puffin-ice-cbd-liposomal-muscle-rub/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/frontpage/products/sour-lifter-cbd-flower") {
   window.location.href = 'https://thehemphaus.com/products/sour-lifter-cbd-flower/'; 
}
if (window.location.href == "https://thehemphaus.com/pages/delta-3-carene") {
   window.location.href = 'https://thehemphaus.com/pages/delta-3-carene/'; 
}
if (window.location.href == "https://thehemphaus.com/products/baileys-cbd-600mg-60ml") {
   window.location.href = 'https://thehemphaus.com/products/baileys-cbd-600mg-60ml/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/frontpage/products/special-sauce-cbd-hemp-flower-light-assisted-greenhouse") {
   window.location.href = 'https://thehemphaus.com/products/special-sauce-cbd-hemp-flower-light-assisted-greenhouse/'; 
}
if (window.location.href == "https://thehemphaus.com/products/mendo-breath-delta-8-thc-pre-rolls") {
   window.location.href = 'https://thehemphaus.com/products/mendo-breath-delta-8-thc-pre-rolls/'; 
}
if (window.location.href == "https://thehemphaus.com/products/northern-lights-cbg-hemp-flower-light-assisted-greenhouse") {
   window.location.href = 'https://thehemphaus.com/products/northern-lights-cbg-hemp-flower-light-assisted-greenhouse/'; 
}
if (window.location.href == "https://thehemphaus.com/products/bubba-kush-pre-rolls-delta-8-thc") {
   window.location.href = 'https://thehemphaus.com/products/bubba-kush-pre-rolls-delta-8-thc/'; 
}
if (window.location.href == "https://thehemphaus.com/collections/frontpage/products/joe-exotic-cbd-hemp-flower-light-assisted-greenhouse") {
   window.location.href = 'https://thehemphaus.com/products/joe-exotic-cbd-hemp-flower-light-assisted-greenhouse/'; 
}
if (window.location.href == "https://www.thehemphaus.com/blogs/news/understanding-liposome-technology-the-ultimate-uber-for-your-supplements") {
   window.location.href = 'https://www.thehemphaus.com/blogs/news/understanding-liposome-technology-the-ultimate-uber-for-your-supplements/'; 
}
if (window.location.href == "https://thehemphaus.com/products/zkittlez-cbg-isolate") {
   window.location.href = 'https://thehemphaus.com/products/cbg-isolate/'; 
}
if (window.location.href == "https://thehemphaus.com/pages/%20https://thehemphaus.com/blogs/news/why-we-trust-puffin-hemp-a-proven-innovative-cbd-formula-forging-the-path-in-hemp-science") {
   window.location.href = 'https://thehemphaus.com/blogs/news/why-we-trust-puffin-hemp-a-proven-innovative-cbd-formula-forging-the-path-in-hemp-science/'; 
}

